import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';

import { CmsPostPageBody } from './Body/CmsPostPageBody';
import { CmsPostPageLayout } from './Layout/CmsPostPageLayout';

type Props = {
  content: CmsApiPagePost;
};

export function CmsPostPage({ content }: Props) {
  return (
    <CmsPostPageLayout content={content}>
      <CmsPostPageBody content={content} />
    </CmsPostPageLayout>
  );
}
